import MuiAlert from './MuiAlert';
import MuiAutocomplete from './MuiAutocomplete';
import MuiBadge from './MuiBadge';
import MuiButton from './MuiButton';
import MuiCheckbox from './MuiCheckbox';
import MuiChip from './MuiChip';
import MuiFilledInput from './MuiFilledInput';
import MuiFormHelperText from './MuiFormHelperText';
import MuiInput from './MuiInput';
import MuiInputAdornment from './MuiInputAdornment';
import MuiInputLabel from './MuiInputLabel';
import MuiLinearProgress from './MuiLinearProgress';
import MuiLink from './MuiLink';
import MuiOutlinedInput from './MuiOutlinedInput';
import MuiRadio from './MuiRadio';
import MuiRating from './MuiRating';
import MuiSelect from './MuiSelect';
import MuiStep from './MuiStep';
import MuiStepConnector from './MuiStepConnector';
import MuiStepLabel from './MuiStepLabel';
import MuiStepper from './MuiStepper';
import MuiTextField from './MuiTextField';
import MuiTooltip from './MuiTooltip';
import MuiTypography from './MuiTypography';
const overrides = {
  MuiAlert,
  MuiAutocomplete,
  MuiBadge,
  MuiButton,
  MuiCheckbox,
  MuiChip,
  MuiFilledInput,
  MuiFormHelperText,
  MuiInput,
  MuiInputAdornment,
  MuiInputLabel,
  MuiLinearProgress,
  MuiLink,
  MuiOutlinedInput,
  MuiRadio,
  MuiRating,
  MuiSelect,
  MuiStep,
  MuiStepConnector,
  MuiStepLabel,
  MuiStepper,
  MuiTextField,
  MuiTooltip,
  MuiTypography
};
export default overrides;